import { z } from 'zod';
export const DEFAULT_WIDGET_CONFIG = {
    brandColor: '#6366f1',
    logoSvg: null,
    buttonPosition: 'bottom-right',
    buttonText: 'Report Bug',
    buttonTooltip: null,
    buttonShadow: true,
    buttonBorderColor: 'transparent',
    hoverEffect: 'no-effect',
    hoverScale: true,
    iconScale: 1.0,
    successMessage: 'Thank you! Your bug report has been submitted.',
    requiredFields: [],
    minDescriptionLength: 20,
    maxDescriptionLength: 2000,
    screenshotRetentionDays: 90,
};
export const ButtonPositionSchema = z.enum([
    'bottom-right',
    'bottom-left',
    'top-right',
    'top-left'
]);
export const RequiredFieldSchema = z.enum(['email', 'screenshot']);
export const HoverEffectSchema = z.enum(['no-effect', 'glow', 'shadow']);
const WidgetConfigBaseSchema = z.object({
    brandColor: z.string()
        .refine((val) => val === 'transparent' || /^#[0-9A-Fa-f]{6}$/.test(val), 'Invalid color: must be hex (e.g., #6366f1) or "transparent"')
        .default(DEFAULT_WIDGET_CONFIG.brandColor),
    logoSvg: z.string()
        .max(50 * 1024, 'SVG must be less than 50KB')
        .nullable()
        .default(null),
    buttonPosition: ButtonPositionSchema.default(DEFAULT_WIDGET_CONFIG.buttonPosition),
    buttonText: z.string()
        .min(1, 'Button text is required')
        .max(50, 'Button text too long')
        .default(DEFAULT_WIDGET_CONFIG.buttonText),
    buttonTooltip: z.string()
        .max(100, 'Tooltip too long')
        .nullable()
        .default(null),
    buttonShadow: z.boolean().default(DEFAULT_WIDGET_CONFIG.buttonShadow),
    buttonBorderColor: z.string()
        .refine((val) => val === 'transparent' || /^#[0-9A-Fa-f]{6}$/.test(val), 'Invalid color: must be hex (e.g., #d1d5db) or "transparent"')
        .default(DEFAULT_WIDGET_CONFIG.buttonBorderColor),
    hoverEffect: HoverEffectSchema.default(DEFAULT_WIDGET_CONFIG.hoverEffect),
    hoverScale: z.boolean().default(DEFAULT_WIDGET_CONFIG.hoverScale),
    iconScale: z.number()
        .min(0.5, 'Icon scale must be at least 0.5')
        .max(2.0, 'Icon scale cannot exceed 2.0')
        .default(DEFAULT_WIDGET_CONFIG.iconScale),
    successMessage: z.string()
        .min(1, 'Success message is required')
        .max(200, 'Success message too long')
        .default(DEFAULT_WIDGET_CONFIG.successMessage),
    requiredFields: z.array(RequiredFieldSchema).default([]),
    minDescriptionLength: z.number()
        .min(0)
        .max(500)
        .default(DEFAULT_WIDGET_CONFIG.minDescriptionLength),
    maxDescriptionLength: z.number()
        .min(100)
        .max(10000)
        .default(DEFAULT_WIDGET_CONFIG.maxDescriptionLength),
    screenshotRetentionDays: z.number()
        .min(30, 'Retention must be at least 30 days')
        .max(365, 'Retention cannot exceed 365 days')
        .default(DEFAULT_WIDGET_CONFIG.screenshotRetentionDays),
});
export const WidgetConfigSchema = WidgetConfigBaseSchema.refine((data) => data.minDescriptionLength <= data.maxDescriptionLength, { message: 'minDescriptionLength must be <= maxDescriptionLength' });
export const WidgetConfigUpdateSchema = WidgetConfigBaseSchema.partial();
//# sourceMappingURL=widget-config.js.map